import { INommable } from './nommable.interface';

export class Nommable implements INommable {
  constructor(
    public id: string,
    public libelle: string
  ) {}
}
